import { queryOptions, useMutation } from "@tanstack/react-query";
import { driverRoadTestApi } from "./driver-road-test";

function tenstreetApplicantQueryOptions(data: {
    params: { licenseNumber: string };
    uniqueId: string;
}) {
    return queryOptions({
        queryKey: [
            "driver-road-test",
            "tenstreet-applicants",
            {
                licenseNumber: data.params.licenseNumber,
                uniqueId: data.uniqueId,
            },
        ],
        queryFn: () => driverRoadTestApi.getTenstreetApplicant(data),
        retry: false,
        staleTime: 0,
        gcTime: 0,
    });
}

function driverExamsQueryOptions(data: { params: { licenseNumber: string } }) {
    return queryOptions({
        queryKey: [
            "driver-road-test",
            "exams",
            { licenseNumber: data.params.licenseNumber },
        ],
        queryFn: () => driverRoadTestApi.getDriverExams(data),
        retry: false,
        staleTime: 0,
        gcTime: 0,
    });
}

function driverRoadTestExamTypesQueryOptions() {
    return queryOptions({
        queryKey: ["driver-road-test", "exam-types"],
        queryFn: driverRoadTestApi.getExamTypes,
    });
}

function sectionsWithQuestionsQueryOptions() {
    return queryOptions({
        queryKey: ["driver-road-test", "sections-with-questions"],
        queryFn: () => driverRoadTestApi.getSectionsWithQuestions(),
        retry: false,
        staleTime: 0,
        gcTime: 0,
        refetchOnWindowFocus: false,
    });
}

function useCreateExam() {
    return useMutation({
        mutationKey: ["driver-road-test", "create-exam"],
        mutationFn: driverRoadTestApi.createExam,
    });
}

function useUpdateExam() {
    return useMutation({
        mutationKey: ["driver-road-test", "update-exam"],
        mutationFn: driverRoadTestApi.updateExam,
    });
}

function useCompleteExam() {
    return useMutation({
        mutationKey: ["driver-road-test", "complete"],
        mutationFn: driverRoadTestApi.completeExam,
    });
}

function certificateQueryOptions(data: {
    params: { certificateName: string };
}) {
    return queryOptions({
        queryKey: [
            "driver-road-test",
            "certificate",
            {
                certificateName: data.params.certificateName,
            },
        ],
        queryFn: () => driverRoadTestApi.getCertificate(data),
    });
}

const driverRoadTestQueryOptions = {
    tenstreetApplicantQueryOptions,
    driverExamsQueryOptions,
    driverRoadTestExamTypesQueryOptions,
    sectionsWithQuestionsQueryOptions,
    useCreateExam,
    useUpdateExam,
    certificateQueryOptions,
};

const driverRoadTestMutations = {
    useCreateExam,
    useCompleteExam,
};

export { driverRoadTestQueryOptions, driverRoadTestMutations };
